import type * as core from '../../../../../../../core'

export const query: core.mosaic.Page.Query = {
  filter: {
    '=': [
      {
        '@.': '!id',
      },
      {
        '@$': 'awardId',
      },
    ],
  },
  target: 'ent:!awards:!award',
  quantity: 1,
  selection: {
    '{}': {
      title: {
        '@.': '!name',
      },
      breadcrumbs: {
        '[]': [
          {
            '{}': {
              goto: {
                '{}': {
                  navigationId: 'awards',
                },
              },
              name: 'Awards',
            },
          },
        ],
      },
    },
  },
}
